var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ds-control ds-datagrid-cell-content ds-no-padding"},[_vm._t(_vm.slots[0].name)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }